module.exports = __webpack_public_path__ + "static/img/Creditagricole.4077606.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/partners/Creditagricole.svg
// module id = lCza
// module chunks = 0